var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 25.934 25.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_741",
    "data-name": "\\u7EC4 741",
    transform: "translate(-1789.069 -1046.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_339",
    "data-name": "\\u8DEF\\u5F84 339",
    d: "M1801.225,1046.963h1.621c.433.056.869.1,1.3.17A13.015,13.015,0,0,1,1814.8,1057.7c.084.471.133.949.2,1.424v1.62a1.354,1.354,0,0,0-.042.2,12.4,12.4,0,0,1-1.771,5.585,12.825,12.825,0,0,1-8.922,6.178c-.47.088-.948.133-1.422.2h-1.621c-.316-.039-.633-.073-.949-.118a13.022,13.022,0,0,1-11.005-10.59c-.087-.479-.136-.965-.2-1.449v-1.62c.039-.317.072-.635.117-.95a13.016,13.016,0,0,1,10.616-11.008C1800.274,1047.079,1800.751,1047.029,1801.225,1046.963Zm4.253,5.931a.291.291,0,0,0-.081-.027c-.936.007-1.877-.041-2.807.039a2.545,2.545,0,0,0-2.34,1.836,5.628,5.628,0,0,0-.221,1.365c-.036.528-.008,1.06-.008,1.619h-1.464v2.669h1.471v7.493h3.13v-7.515h2.1l.27-2.65h-2.381v-1.411c0-.677.193-.868.878-.868h1.449Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFilled);
export default __webpack_public_path__ + "static/media/facebook_filled.90bbc0cb.svg";
export { ForwardRef as ReactComponent };